import React from 'react';
import { TAGS_MAP, TagsIcon, TagsKey } from '../../conversations';
import { camelCase, startCase } from 'lodash';
import { TouchableOpacity } from '@zonofi/seller-hub/common';

const MAX_VISIBLE_TAGS = 2;
const findTagType = (tag: string): TagsKey => {
  return (
    (Object.entries(TAGS_MAP).find(([_, values]) =>
      values.includes(tag)
    )?.[0] as TagsKey) ?? 'custom'
  );
};

export const CustomerConversationTag: React.FC<{
  conversationTags: any;
}> = ({ conversationTags = [] }) => {
  const [showAll, setShowAll] = React.useState(false);

  const allTags =
    conversationTags?.map((tag: string, idx: number) => {
      const tagKey = findTagType(tag);

      return {
        key: `tag-${idx}-${tag}`,
        element: (
          <div
            className={`customer-details-tags-each ${tagKey} font-semibold`}
            key={`tag-${idx}`}
          >
            {TagsIcon[tagKey]} {startCase(camelCase(tag))}
          </div>
        ),
      };
    }) || [];

  const visibleTags = showAll ? allTags : allTags.slice(0, MAX_VISIBLE_TAGS);
  const hiddenCount = allTags.length - MAX_VISIBLE_TAGS;

  if (allTags.length === 0) return null;

  return (
    <div className="customer-details-tags-row">
      {visibleTags.map(
        ({ key, element }: { key: string; element: React.ReactNode }) => (
          <React.Fragment key={key}>{element}</React.Fragment>
        )
      )}

      {!showAll && hiddenCount > 0 && (
        <TouchableOpacity
          className="customer-details-tags-more font-semibold"
          onPress={(e) => {
            setShowAll(true);
          }}
        >
          +{hiddenCount}
        </TouchableOpacity>
      )}
    </div>
  );
};
